import NavbarComponent from "./NavbarComponent";
import FooterComponent from "./FooterComponent";
//import SnackbarWIP from "./SnackbarWIP";
import { Container } from "reactstrap";
import "../styles/Layout.css";

const Layout = (props) => {
  return (
    <div>
      <NavbarComponent expand="sm" fixed="top" />
      <Container className="main-content" tag="main">
        {props.children}
      </Container>
      {/* <SnackbarWIP open={true} /> */}
      <FooterComponent />
    </div>
  );
};

export default Layout;
